<template>
  <div class="page page--terms">
    <div class="container text-center">
      <h1>Page Not Found</h1>

      <div class="leading-loose">
        <br>
        <p>The requested page could not be found.</p>
        <br>
        <p><router-link :to="routes.home" class="btn btn-active">Back to Homepage</router-link></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
}
</script>
